import {
  formatCurrency,
  formatNumber,
  getSinglarOrPluralWord,
} from './../../../../utilities/helpers'

import Button from 'react-bootstrap/Button'
import Stack from 'react-bootstrap/Stack'

import { Spinner } from '../../../LoadingContainer/Spinner'
import useFiltersStore from '../../../../stores/filtersStore'
import {
  resolveButtonColor,
  resolveButtonTextColor,
  resolvePrimaryColor,
} from '../../utils/branding'

import './sheetBottom.scss'

function resolveCheckoutButtonColors(event) {
  const accent = resolvePrimaryColor(event, event?.organization)
  const background = resolveButtonColor(event, event?.organization, accent)
  if (!background) return null

  return {
    background,
    color: resolveButtonTextColor(event, event?.organization),
  }
}

export default function SheetBottom({
  VSButton = false,
  VSClick = undefined,
  selectedTicketCount,
  totalTicketsPrice,
  processingFee = 0,
  showProcessingFee = false,
  feeLines = [],
  checkout,
  checkingAvailability,
}) {
  const event = useFiltersStore((state) => state.event)
  const brandButton = resolveCheckoutButtonColors(event)
  const addedFees = (Array.isArray(feeLines) ? feeLines : []).filter(
    (line) => Number(line?.amount) > 0
  )
  const addedFeeTotal = addedFees.reduce(
    (sum, line) => sum + Number(line.amount),
    0
  )
  const hasProcessingFee = showProcessingFee && processingFee > 0
  const totalWithProcessingFee =
    totalTicketsPrice + addedFeeTotal + (hasProcessingFee ? processingFee : 0)
  const showTotal = hasProcessingFee || addedFees.length > 0

  return (
    <div
      className="vjx-sb"
      style={
        brandButton
          ? {
              '--vjx-checkout-bg': brandButton.background,
              '--vjx-checkout-color': brandButton.color,
            }
          : undefined
      }
    >
      <div className="vjx-sbt">
        <div className="vjx-sbl">
          <span className="vjx-ss1">Subtotal</span>
          <span className="vjx-ss2">
            {formatNumber(selectedTicketCount)}{' '}
            {getSinglarOrPluralWord(selectedTicketCount)}
          </span>
        </div>
        <span className="vjx-ss3">{formatCurrency(totalTicketsPrice)}</span>
      </div>
      {addedFees.map((line) => (
        <div className="vjx-sbt" key={line.id || line.name}>
          <div className="vjx-sbl">
            <span className="vjx-ss1">{line.name}</span>
          </div>
          <span className="vjx-ss3">{formatCurrency(line.amount)}</span>
        </div>
      ))}
      {showTotal && (
        <>
          {hasProcessingFee && (
            <div className="vjx-sbt">
              <div className="vjx-sbl">
                <span className="vjx-ss1">Processing fee</span>
              </div>
              <span className="vjx-ss3">{formatCurrency(processingFee)}</span>
            </div>
          )}
          <div className="vjx-sbt">
            <div className="vjx-sbl">
              <span className="vjx-ss1">Total</span>
            </div>
            <span className="vjx-ss3">
              {formatCurrency(totalWithProcessingFee)}
            </span>
          </div>
        </>
      )}
      <Stack
        direction="horizontal"
        className="btn-group-flex mt-2 btn-group-flex-stretch"
      >
        {VSButton && (
          <Button onClick={VSClick} variant="outline-light" size="lg">
            View selection
          </Button>
        )}
        <Button
          disabled={checkingAvailability}
          variant="primary"
          className={`icon-button${brandButton ? ' vjx-checkout-btn--branded' : ''}`}
          size="lg"
          onClick={checkout}
        >
          {checkingAvailability ? (
            <>
              {!VSButton && 'Checking availability '}
              <Spinner />
            </>
          ) : (
            'Checkout'
          )}
        </Button>
      </Stack>
    </div>
  )
}
